<template>
  <div>
    <v-btn :disabled="flatRows.length == 0" @click="exportExcel" width="150" color="primary" class="light--text text-capitalize">
      <v-icon size="17" class="me-1">mdi-export</v-icon>Export
    </v-btn>
    <div v-show="false">
      <div id="printMeDetailed">
        <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 12px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Sl.No</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Sales Order No</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Client Name</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Customer Account</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Delivery Date</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Availed Package Day</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Total Package Days</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Gross Sales Amount</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Discount Amount</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Net Sales Amount</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Program Name</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Gender</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Delivery Location</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Clinic Name</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Promo Code</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Referral ID</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Created Date</th>
              <th style="border: 1px solid #000; padding: 8px 10px; background-color: #c0392b; color: #fff; white-space: nowrap;">Created By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in flatRows" :key="row.slNo">
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center;">{{ row.slNo }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center; white-space: nowrap;">{{ row.salesOrderNo }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.clientName }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center;">{{ row.customerAccount }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center; white-space: nowrap;">{{ row.deliveryDate }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center;">{{ row.programDay }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center;">{{ row.totalPackageDays }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: right;">{{ row.grossSalesAmount }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: right;">{{ row.discountAmount }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: right;">{{ row.netSalesAmount }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.programName }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; text-align: center; white-space: nowrap;">{{ row.gender }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.deliveryLocation }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.clinicName }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.promoCode }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.referralId }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.createdDate }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; white-space: nowrap;">{{ row.createdBy }}</td>
            </tr>
            <tr>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3; font-weight: bold;">Total</td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3; text-align: right; font-weight: bold;">{{ totalGross }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3; text-align: right; font-weight: bold;">{{ totalDiscount }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3; text-align: right; font-weight: bold;">{{ totalNet }}</td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
              <td style="border: 1px solid #000; padding: 6px 10px; background-color: #fef9c3;"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Utils } from "../../utils/utils";

export default {
  props: {
    flatRows: {
      required: true,
    },
  },
  methods: {
    exportExcel() {
      Utils.htmlToExcel("printMeDetailed", "Financial Report", false);
    },
  },
  computed: {
    totalGross() {
      return this.flatRows.reduce((sum, row) => sum + parseFloat(row.grossSalesAmount), 0).toFixed(3);
    },
    totalDiscount() {
      return this.flatRows.reduce((sum, row) => sum + parseFloat(row.discountAmount), 0).toFixed(3);
    },
    totalNet() {
      return this.flatRows.reduce((sum, row) => sum + parseFloat(row.netSalesAmount), 0).toFixed(3);
    },
  },
};
</script>